import React from "react";
import ConfigProvider from "./common/ConfigProvider";
import PropTypes from "prop-types";
import Avatar from "./common/Avatar";
import Card from "./common/Card";
import moment from 'moment';
import ti18n from 'i18n!nls/Sequenceri18n';
import SequencerSearchWidget from "../models/audioEditor/SequencerSearchWidget";
import SequencerRendererUtils  from "models/audioEditor/SequencerRendererUtils"
import useDefaultTrebbleAntDTokenConfig from "./helper/useDefaultTrebbleAntDTokenConfig";
import Tooltip from "./common/Tooltip";
import Utils from "../models/helper/Utils";

const SEARCH_TYPE = SequencerSearchWidget.SEARCH_TYPE;
const EditorSearchCommentItem = (props) =>
{
    const themeConfig = useDefaultTrebbleAntDTokenConfig({useEditorTheme: true});
    const onApplyButtonClick = (e)=>{
        // Prevent event bubbling to parent onClick handler
        if(e && e.stopPropagation){
            e.stopPropagation();
        }
        
        if(props.onApplyButtonClick){
            props.onApplyButtonClick()
        }
        // Addition suggestions: dismiss is handled in EditorSearchPanel.onApplyButtonClick
        // Note: For other search types, the auto-jump logic is now handled in EditorSearchPanel's onApplyButtonClick
        // which calls deleteSelectedNodesWithAutoJumpLogic instead of calling applyActionToCurrentResultInFocus here
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("sequencer", 'searchResultMainActionApplied', 'search result main action applied', getPropsForTracking(props));
        }
    }

    const getPropsForTracking = (props)=>{
        const searchResultArraySummary = Utils.getInstance().getSummaryDescriptionOfSequencerNodeArray(props.searchResultArray);
        
        return {
            ...searchResultArraySummary, 
            uid: props.uid,
            commenterName: props.commenterName,
            searchType: props.searchType,
            typeLabel: props.typeLabel,
            description: props.description,
            type: props.description,
            confidence: props.confidence,
            confidenceLabel: props.confidenceLabel,
            reason: props.reason,
            recommendation: props.recommendation,
            recommendationLabel: props.recommendationLabel,
            index: props.index,
            searchRequestId: props.searchRequestId,
        };
    }

    const onPlayWithSelectionButtonClick= ()=>{
        if(props.onPlayWithSelectionButtonClick){
            props.onPlayWithSelectionButtonClick()
        }else{
            SequencerRendererUtils.getInstance().playWithSelectionButtonClick(props.sequencer, props.searchResultArray[0], props.searchResultArray[props.searchResultArray.length-1], SEARCH_TYPE.EDIT_BOUNDARIES === props.searchType ,false, getNumberOfWordsBeforeAndAfterToPlay());
        }
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("sequencer", 'searchResultPlayWithSelection', 'search result play with selection', getPropsForTracking(props));
        }
    }

    const onPlayWithoutSelectionButtonClick= ()=>{
        if(props.onPlayWithoutSelectionButtonClick){
            props.onPlayWithoutSelectionButtonClick()
        }else{
            SequencerRendererUtils.getInstance().playWithoutSelectionButtonClick(props.sequencer, props.searchResultArray[0], props.searchResultArray[props.searchResultArray.length-1], SEARCH_TYPE.EDIT_BOUNDARIES === props.searchType, getNumberOfWordsBeforeAndAfterToPlay());
        }
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("sequencer", 'searchResultPlayWithoutSelection', 'search result play without selection',getPropsForTracking(props));
        }
    }


    const onPlayWithSelectionAndReconstructGapsButtonClick = ()=>{
        if(props.onPlayWithSelectionButtonClick){
            props.onPlayWithSelectionButtonClick()
        }else{
            SequencerRendererUtils.getInstance().playWithSelectionButtonClick(props.sequencer, props.searchResultArray[0], props.searchResultArray[props.searchResultArray.length-1], SEARCH_TYPE.EDIT_BOUNDARIES === props.searchType , true, getNumberOfWordsBeforeAndAfterToPlay());
        }
    }

    const getNumberOfWordsBeforeAndAfterToPlay = ()=>{
        if(SEARCH_TYPE.EDIT_BOUNDARIES === props.searchType){
            return 10;
        }
        if(SEARCH_TYPE.SEMANTIC_SEARCH === props.searchType){
            return 10;
        }
        if(SEARCH_TYPE.AI_EDIT_SUGGESTIONS === props.searchType){
            return 10;
        }
        return 4;
    }

    const onDismissButtonClick = (e)=>{
        // Prevent event bubbling to parent onClick handler
        if(e && e.stopPropagation){
            e.stopPropagation();
        }
        
        // Use the specific result index instead of current focus
        props.sequencer.getSearchWidget().dismissSpecificSearchResult(props.index);
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("sequencer", 'searchResultDismissed', 'search result dismissed',getPropsForTracking(props));
        }
    }

    

    return (
        <ConfigProvider theme={ themeConfig }>
            <Card useEditorTheme={true} size="small" hoverable={false} style={{outlineStyle:props.selected?"solid":"none"}} className={`search-result-item-card ${themeConfig.inDarkMode?"":"border-neutral-300"} bg-transparent ${props.selected? `search-result-item-card-selected outline-2 ${themeConfig.inDarkMode?'':'bg-white'} outline-offset-2 outline-solid ${themeConfig.inDarkMode?"outline-primary":"outline-black"} `: `hover:bg-neutral-200 hover:border-neutral-300 ${themeConfig.inDarkMode? "hover:text-slate-700": ""}`} hover:cursor-pointer `} onClick={props.onClick}>
            <div className="flex flex-col">
                {props.commenterName && <div className="flex flex-row">
                    <div className="flex flex-col">
                        <Avatar/>
                    </div>
                    <div className="flex flex-col">
                        {props.commenterName}
                    </div>
                    {props.publishedDateTimestap && <div className="flex flex-col">
                        {moment(new Date(props.publishedDateTimestap)).fromNow()}
                    </div>}
                </div>}
                {props.description && <div className="flex flex-row">
                    <div className="flex flex-col">
                        <span className="text-start">{props.descriptionParts ? <>
                            {props.descriptionParts.before}
                            {props.descriptionParts.highlighted && <span className="bg-yellow-300 text-black whitespace-break-spaces">{props.descriptionParts.highlighted}</span>}
                            {props.descriptionParts.after}
                            {props.descriptionParts.detail && <span style={{opacity: 0.6}}>{props.descriptionParts.detail}</span>}
                        </> : props.description}</span>
                    </div>
                </div>}
                {(SEARCH_TYPE.SEMANTIC_SEARCH == props.searchType || SEARCH_TYPE.AI_EDIT_SUGGESTIONS == props.searchType || props.searchType === "additionSuggestion") && props.selected && (props.reason || props.streamlinedSuggestionConfidenceLabel || props.typeLabel) && <div className="flex flex-row text-left">
                    <div className="">
                        {props.typeLabel && <><b>{window.getI18n(ti18n, "TYPE")}: </b><span className="bold">{props.typeLabel}</span><br/></>}
                        {props.streamlinedSuggestionConfidenceLabel && <><b>{window.getI18n(ti18n, "CONFIDENCE")}: </b><span className="bold">{props.streamlinedSuggestionConfidenceLabel}</span><br/></>}
                        {props.recommendationLabel && false && <><b>Recommendation: </b><span className="bold">{props.recommendationLabel}</span><br/></>}
                        {props.reason && <><b>{window.getI18n(ti18n, "REASON")}: </b><span className="italic">{Utils.getInstance().removeWordIdsFromTranscription(props.reason)}</span><br/></>}
                    </div>
                </div>}
               {props.selected && <div className="flex flex-row items-center justify-between mt-1">
                    {/* Play buttons on the left — hidden for addition suggestions */}
                    <div className="flex flex-row items-center">
                        {props.searchType !== "additionSuggestion" && (SEARCH_TYPE.EDIT_BOUNDARIES == props.searchType) && <div className="flex flex-col">
                            <Tooltip title={window.getI18n(ti18n,"PLAY_WITH_STRIKETHROUGH_CONTENT")} placement="bottom" align="center">
                            <button onClick={onPlayWithSelectionAndReconstructGapsButtonClick} className="hint--bottom hover:bg-primary-light text-primary" disabled=""><span className="icon pe-7s-play text-3xl relative"><span className="icon strikethrough-icon menu_icon text-sm right-0 absolute bottom-0">S</span></span></button>
                            </Tooltip>
                        </div>}
                        {props.searchType !== "additionSuggestion" && !(SEARCH_TYPE.EDIT_BOUNDARIES == props.searchType) && <div className="flex flex-col">
                            <Tooltip title={window.getI18n(ti18n,"PLAY_BUT_SELECTED_HIGHLIGHT")} placement="bottom" align="center">
                            <button onClick={onPlayWithoutSelectionButtonClick} className="hint--bottom hover:bg-primary-light text-primary" disabled=""><span className="icon pe-7s-play text-3xl relative"><span className="icon soundwave-next_1 text-sm right-0 absolute bottom-0"></span></span></button>
                            </Tooltip>
                        </div>}
                        {props.searchType !== "additionSuggestion" && <div className="flex flex-col">
                            <Tooltip title={window.getI18n(ti18n,"PLAY_SELECTED_HIGHLIGHT")} placement="bottom" align="center">
                            <button onClick={onPlayWithSelectionButtonClick} className="hint--bottom hover:bg-primary-light text-primary" disabled=""><span className="icon pe-7s-play text-3xl relative"><span className="icon soundwave-highlight text-sm right-0 absolute bottom-0"></span></span></button>
                            </Tooltip>
                        </div>}
                    </div>
                    {/* Action buttons always on the right */}
                    <div className="flex flex-row items-center gap-2 ml-auto">
                        <button className="button_with_label secondary border-2 border-black bg-gray" onClick={onDismissButtonClick}><label>{props.dismissActionButtonLabel || window.getI18n(ti18n, "DISMISS")}</label></button>
                        {!(SEARCH_TYPE.EDIT_BOUNDARIES == props.searchType) && <button className="button_with_label border-2 border-black" onClick={onApplyButtonClick}><label>{props.applyActionButtonLabel || (props.searchType === "additionSuggestion" ? window.getI18n(ti18n, "ADD_TO_EDIT") : window.getI18n(ti18n, "REMOVE"))}</label></button>}
                    </div>
                </div>}
                { false && <div className="flex flex-row justify-center flex-auto mt-2">
                    <div className="flex flex-col flex-auto">
                        <button id="approveBtn" className="button_with_label" disabled=""><span className="icon pe-7s-check" ></span><label>Approve</label></button>
                    </div>
                    
                </div>}
                {false && <div className="flex flex-row flex-auto">
                    <div className="flex flex-col flex-auto">
                        <button id="updateBtn" className="button_with_label" disabled=""><span className="icon pe-7s-refresh-2"></span><label>Request Changes</label></button>
                    </div>
                    <div className="flex flex-col flex-auto">
                        <button id="rejectBtn" className="button_with_label" disabled=""><span className="icon pe-7s-close-circle"></span><label>Reject</label></button>
                    </div>
                </div>}
            </div>
            </Card>
        </ConfigProvider>
    );
};
EditorSearchCommentItem.propTypes = {
    uid: PropTypes.string,
    commenterName: PropTypes.string,
    searchType: PropTypes.string,
    publishedDateTimestap: PropTypes.number,
    typeLabel: PropTypes.string,
    description: PropTypes.string,
    descriptionParts: PropTypes.shape({
        before: PropTypes.string,
        highlighted: PropTypes.string,
        after: PropTypes.string,
        detail: PropTypes.string,
    }),
    type: PropTypes.string,
    confidence: PropTypes.string,
    confidenceLabel: PropTypes.string,
    reason: PropTypes.string,
    recommendation: PropTypes.string,
    recommendationLabel: PropTypes.string,
    streamlinedSuggestionConfidence: PropTypes.string,
    streamlinedSuggestionConfidenceLabel: PropTypes.string,
    applyActionButtonLabel: PropTypes.string,
    dismissActionButtonLabel: PropTypes.string,
    index: PropTypes.number,
    sequencer: PropTypes.object,
    onDismissButtonClick: PropTypes.func,
    onApplyButtonClick: PropTypes.func,
    onPlayWithSelectionButtonClick: PropTypes.func,
    onPlayWithoutSelectionButtonClick: PropTypes.func,
    searchResultArray: PropTypes.array,
    searchRequestId: PropTypes.string,
    locale: PropTypes.object,
    selected: PropTypes.bool,
    onClick: PropTypes.func
};


export default EditorSearchCommentItem;
